import { render, staticRenderFns } from "./loginFlow.vue?vue&type=template&id=2470720e"
import script from "./loginFlow.vue?vue&type=script&lang=js"
export * from "./loginFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports